import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getPittsburghStructuredData() {
  const url = "https://restorehair.com/locations/pennsylvania/pittsburgh/";
  const description =
    "Find out about your hair transplant options in Pittsburgh with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("pittsburgh", url, description),
    locationPageCrumbs(url, "Pittsburgh"),
  ];
}
